




























































import { Vue, Component } from 'vue-property-decorator'
import utility from '@/common/utility'
import SearchFilter from '@/components/search-filter.vue'
import SortHeader from '@/components/SortHeader.vue'
import UpDownBar from '@/views/Report/UpDownBar.vue'
import binanceService, { AccountTrade } from '@/services/binanceService'
let pageItems: AccountTrade[] = []

@Component({
  components: { UpDownBar, SortHeader, SearchFilter }
})
export default class BinanceTrades extends Vue {
  trades: AccountTrade[] = []
  selectedSymbols = new Array<string>()
  symbols: string[] = []
  loading = false

  async mounted () {
    await this.loadData(false)
  }

  refresh () {
    this.loadData(true)
  }

  async loadData (forceUpdate: boolean) {
    this.loading = true
    const data = await binanceService.getTrades(forceUpdate)
    this.loading = false
    if (data.Error) {
      await this.$alert(data.Error)
      return
    }
    pageItems = data.Result
    this.symbols = utility.getDistinct(data.Result.map(p => p.Symbol))
    this.trades = utility.freezeArrayItems(pageItems)
  }

  sortSymbol (direction: 'Asc' | 'Desc') {
    utility.sortByFiled(this.trades, direction, p => p.Symbol)
  }

  private filterSymbols () {
    const filter = pageItems.filter(p => this.selectedSymbols.length === 0 || this.selectedSymbols.find(q => q === p.Symbol))
    this.trades = utility.freezeArrayItems(filter)
  }

  async download () {
    try {
      const blob = await binanceService.downloadTrades()
      utility.download('trades.csv', blob, 'application/octet-stream')
    } catch (e) {
      await this.$alert(e)
    }
  }
}
